export default __webpack_public_path__ + "static/media/faktur-penjualan.39321a8e.png";